export default {
  namespaced: true,
  distribution_list: {
    title: "lista de distribuição",
    sidebar: {
      list_name: "nome",
      users: "usuários",
      email: "e-mails",
    },
    table_distribution: {
      title: "lista",
      name: "nome",
      emails: "e-mails",
      noemails: "sem e-mails",
      successful_creation: "Lista de distribuição criada com sucesso",
      error_creation: "Erro ao criar a lista de distribuição",
      successful_edit: "Lista de distribuição editada com sucesso",
      error_edit: "Erro ao editar a lista de distribuição",
      successful_delete: "Lista de distribuição excluída com sucesso",
      error_delete: "Erro ao excluir a lista de distribuição",
      users_count: 'número de usuários',
      emails_count: 'número de emails',
    }
  }
};
